// extracted by mini-css-extract-plugin
export default {"searchBox":"bz_gW","resultsOpen":"bz_gX"};